import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    background-color: ${({ theme }) => theme.palette.primary.background};
    border-radius: 21px;
  }
`;

export const Contacts = styled.div`
  display: grid;
  justify-items: center;
  gap: 15px;
  padding: 30px 0;
`;

export const ContactsText = styled(Typography.Body)`
  text-align: center;
`;

export const SettingsButton = styled(Button).attrs({
  isFullWidth: true,
  borderRadius: 14,
})``;
